import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from 'react';
import { cn } from '@stadium/ui/utils';
type StoreCardRootProps = ComponentProps<'details'>;
function StoreCardRoot(t0) {
  const $ = _c(10);
  let children;
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("rounded-shape-sm bg-surface border-core-c-300 @container border", className, "transition-[border-color] duration-300", "open:border-core", "details-content:duration-300", "details-content:h-0", "details-content:ease-in-out", "details-content:transition-discrete", "details-content:transition-[height,content-visibility]", "details-content:overflow-clip", "open:details-content:h-auto", "not-supports-[interpolate-size:allow-keywords]:details-content:transition-none");
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== rest || $[8] !== t1) {
    t2 = <details {...rest} className={t1}>{children}</details>;
    $[6] = children;
    $[7] = rest;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
type StoreCardSummaryProps = ComponentProps<'summary'>;
function StoreCardSummary(t0) {
  const $ = _c(10);
  let children;
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("block cursor-pointer p-4 @md:p-6", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== rest || $[8] !== t1) {
    t2 = <summary {...rest} className={t1}>{children}</summary>;
    $[6] = children;
    $[7] = rest;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
type StoreCardContentProps = ComponentProps<'div'>;
function StoreCardContent(t0) {
  const $ = _c(10);
  let children;
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("p-4 pt-0 @md:px-6 @md:pb-6", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== rest || $[8] !== t1) {
    t2 = <div {...rest} className={t1}>{children}</div>;
    $[6] = children;
    $[7] = rest;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
function StoreCardSkeleton(t0) {
  const $ = _c(7);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("rounded-shape-sm bg-surface border-core-c-300 @container border", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = children ?? <div className="space-y-2 p-4 @md:p-6"><div className="rounded-shape-sm bg-surface-s-1 h-5 w-1/3" /><div className="rounded-shape-sm bg-surface-s-1 h-4 w-1/4" /></div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export const StoreCard = {
  Root: StoreCardRoot,
  Summary: StoreCardSummary,
  Content: StoreCardContent,
  Skeleton: StoreCardSkeleton
};